import {createDatatableColumnRegistry} from "@/src/modules/core/lib/datatable-columns";

export const SHIFT_HISTORY_TABLE_COLUMN_IDS = [
  "properties",
  "planned_start",
  "planned_end",
  "actual_start",
  "actual_end",
  "status",
] as const;

export type ShiftHistoryTableColumnId = (typeof SHIFT_HISTORY_TABLE_COLUMN_IDS)[number];

const COLUMN_DEFS = [
  {id: "properties", label: "Properties", defaultVisible: true},
  {id: "planned_start", label: "Planned Start", defaultVisible: true},
  {id: "planned_end", label: "Planned End", defaultVisible: true},
  {id: "actual_start", label: "Actual Start", defaultVisible: true},
  {id: "actual_end", label: "Actual End", defaultVisible: true},
  {id: "status", label: "Status", defaultVisible: true},
] as const satisfies readonly {
  id: ShiftHistoryTableColumnId;
  label: string;
  defaultVisible: boolean;
}[];

export const shiftHistoryTableColumns = createDatatableColumnRegistry(
  SHIFT_HISTORY_TABLE_COLUMN_IDS,
  COLUMN_DEFS,
);

export const getAvailableShiftHistoryTableColumns = shiftHistoryTableColumns.getAvailableColumns;
export const getOrderedVisibleShiftHistoryColumns =
  shiftHistoryTableColumns.getOrderedVisibleColumns;
